import { ServerTag } from './ServerTag';

/**
 * Shows a deletion countdown tag when a server is scheduled for deletion within 3 days.
 * Uses deleteAfter timestamp from the editor record.
 */
export const DeletionCountdownTag = ({ deleteAfter }: { deleteAfter?: string | null }) => {
  if (!deleteAfter) return null;

  const now = new Date();
  const deleteDate = new Date(deleteAfter);
  const msRemaining = deleteDate.getTime() - now.getTime();
  const daysRemaining = Math.ceil(msRemaining / (24 * 60 * 60 * 1000));

  // Only show tag when 3 days or less remain
  if (daysRemaining > 3) return null;

  const text =
    daysRemaining <= 0
      ? 'Deletion pending'
      : `Deletes in ${daysRemaining} day${daysRemaining > 1 ? 's' : ''}`;

  return (
    <ServerTag label={text} color="warning" variant="caption2" sx={{ whiteSpace: 'nowrap' }} />
  );
};
